import React, { useEffect, useRef } from 'react'
import { AlertTriangle, RefreshCcw, Save, Slash, Trash2 } from 'react-feather'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { startRegisterMembresias, startRegistroProducto, startUpdateMembresia } from '../../../../app/store/catalagos/thunks';

export const M_Membresias = ({ selectedMembresia }) => {
    const { status, isLoading } = useSelector(state => state.catalogos);
    const { usuario } = useSelector(state => state.usuario);
    const solo_num = (e) => {
        const allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Tab', 'Decimal', '.'
        ];

        const inputValue = e.target.value;
        const hasDecimal = inputValue.includes('.');

        // Si ya existe un punto decimal, solo permitir dos dígitos después de él
        if (hasDecimal && inputValue.split('.')[1].length >= 2 && (e.key >= '0' && e.key <= '9')) {
            e.preventDefault(); // Evitar más de 2 dígitos después del punto decimal
            return;
        }

        if (
            (e.key >= '0' && e.key <= '9') || // Números
            allowedKeys.includes(e.key) // Otras teclas permitidas
        ) {
            return true;
        } else {
            e.preventDefault(); // Evitar cualquier otra tecla
        }
    };

    const dispatch = useDispatch();
    const closeModal = useRef(null);

    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();

    useEffect(() => {
        if (status == 'Membresias obtenidas') {
            reset();
            closeModal.current.click();
        }
    }, [status])


    const save = (data) => {
        // console.log(data);
        let flag_membresia = 1;
        if (selectedMembresia) {
            dispatch(startUpdateMembresia(data, selectedMembresia.ID, usuario));
        } else {
            // dispatch(startRegisterMembresias(data, usuario));
            dispatch(startRegistroProducto(usuario, data, flag_membresia));


        }
    }



    useEffect(() => {
        if (selectedMembresia) {
            setValue("nombreProducto", selectedMembresia.NOMBRE);
            setValue("costoProducto", selectedMembresia.COSTO);
            setValue("duracion", selectedMembresia.DURACION);
            setValue("descripcionProducto", selectedMembresia.DESCRIPCION);
            setValue("terminos", selectedMembresia.TERMINOS);
        } else {
            reset();
        }
    }, [selectedMembresia, setValue, reset]);

    return (
        <div className="modal fade" id="membresia" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="membresiaLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5 fw-bold" id="membresiaLabel">{selectedMembresia ? `Edicion de membresia: ${selectedMembresia.NOMBRE}` : "Nueva Membresía"}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => reset()}></button>
                    </div>
                    <form onSubmit={handleSubmit(save)}>
                        <div className="modal-body">
                            <div className="row">
                                {
                                    (selectedMembresia) ?
                                        <div className='col-12'>
                                            <div className="alert alert-dark text-justify" role="alert">
                                                <span className='fw-bold'> Atención...</span><br /> Podra solo editar datos de la membresia. Costos, existencias debera editarse en la seccion de Inventario, se ha agregado como producto.
                                            </div>
                                        </div>
                                        : <></>
                                }
                                {/* Nombre */}
                                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                                    <div className="mb-3">
                                        <label className="form-label">Nombre:</label>
                                        <input type="text" className="form-control" autoComplete='off' {...register("nombreProducto", { required: 'Nombre de la membresia es requerido', minLength: { value: 5, message: 'El nombre debe contener minimo 5 caracteres' } })} />
                                        {
                                            errors.nombreProducto &&
                                            <div className='text-left-5 mt-2'>
                                                <AlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.nombreProducto.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>


                                {/* Codigo Barra */}
                                {
                                    (!selectedMembresia) ?
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                            <div className="mb-2">
                                                <label className="form-label">Codigo barra:</label>
                                                <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} autoComplete='off' {...register("codigoBarraProducto", { required: 'Cod. Barra Requerido.' })} />
                                                {
                                                    errors.codigoBarraProducto &&
                                                    <div className='text-left-5 mt-2'>
                                                        <AlertTriangle size="18" color="#dc3545" />
                                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.codigoBarraProducto.message}</small></span>
                                                    </div>
                                                }
                                            </div>
                                        </div> : <></>
                                }




                                {/* Duraccion */}
                                <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                    <div className="mb-3">
                                        <label className="form-label">Duracion (dias):</label>
                                        <input type="number" className="form-control" {...register("duracion", { required: 'Duracion es requerido' })} onKeyDown={solo_num} />
                                        {
                                            errors.duracion &&
                                            <div className='text-left-5 mt-2'>
                                                <AlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.duracion.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>

                                {/* Costo HDL */}
                                <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                    <div className="mb-3">
                                        <label className="form-label">Costo HDL:</label>
                                        <input type="number" className="form-control" {...register("costoProducto", { required: 'Costo es requerido' })} onKeyDown={solo_num} />
                                        {
                                            errors.costoProducto &&
                                            <div className='text-left-5 mt-2'>
                                                <AlertTriangle size="18" color="#dc3545" />
                                                <span className='text-left-10 fw-bold text-danger'><small>{errors.costoProducto.message}</small></span>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {
                                    (!selectedMembresia) ?
                                        <>


                                            <div className='col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                                <div className="mb-2">
                                                    <label className="form-label">Costo Publico:</label>
                                                    <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} autoComplete='off' {...register("costoPUBProducto", { required: 'Costo Requerido.' })} />
                                                    {
                                                        errors.costoPUBProducto &&
                                                        <div className='text-left-5 mt-2'>
                                                            <AlertTriangle size="18" color="#dc3545" />
                                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.costoPUBProducto.message}</small></span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                                                <div className="mb-2">
                                                    <label className="form-label">Existencia Actual (Stock):</label>
                                                    <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} autoComplete='off' {...register("existenciaProducto", { required: 'Existencia del prod. es requerido.' })} />
                                                    {
                                                        errors.existenciaProducto &&
                                                        <div className='text-left-5 mt-2'>
                                                            <AlertTriangle size="18" color="#dc3545" />
                                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.existenciaProducto.message}</small></span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>


                                            <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                                                <div className="mb-2">
                                                    <label className="form-label"> Existencia Minima:</label>
                                                    <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} autoComplete='off' {...register("existenciaMINProducto", { required: 'Requerido.' })} />
                                                    {
                                                        errors.existenciaMINProducto &&
                                                        <div className='text-left-5 mt-2'>
                                                            <AlertTriangle size="18" color="#dc3545" />
                                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.existenciaMINProducto.message}</small></span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>


                                            <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                                                <div className="mb-2">
                                                    <label className="form-label"> Existencia Maxima:</label>
                                                    <input type="number" className="form-control" aria-label="First name" onKeyDown={solo_num} min={0} autoComplete='off' {...register("existenciaMAXProducto", { required: 'Requerido.' })} />
                                                    {
                                                        errors.existenciaMAXProducto &&
                                                        <div className='text-left-5 mt-2'>
                                                            <AlertTriangle size="18" color="#dc3545" />
                                                            <span className='text-left-10 fw-bold text-danger'><small>{errors.existenciaMAXProducto.message}</small></span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </> : <></>
                                }


                            </div>

                            <div className="mb-3">
                                <label className="form-label">Descripcion: </label>
                                <textarea className="form-control" rows="5" {...register("descripcionProducto", { required: 'Duracion es requerido' })}></textarea>
                                {
                                    errors.descripcionProducto &&
                                    <div className='text-left-5 mt-2'>
                                        <AlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.descripcionProducto.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Terminos y condiciones: </label>
                                <textarea className="form-control" rows="5" {...register("terminos", { required: 'Los terminos son requeridos' })}></textarea>
                                {
                                    errors.terminos &&
                                    <div className='text-left-5 mt-2'>
                                        <AlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.terminos.message}</small></span>
                                    </div>
                                }
                            </div>

                            <input type="hidden" className="form-control" autoComplete='off' {...register("marcaProducto")} defaultValue={1} />
                            <input type="hidden" className="form-control" autoComplete='off' {...register("proveedorProducto")} defaultValue={9} />
                            <input type="hidden" className="form-control" autoComplete='off' {...register("categoriaProducto")} defaultValue={14} />
                            <input type="hidden" className="form-control" autoComplete='off' {...register("modeloProducto")} defaultValue={"NA"} />


                        </div>
                        <div className="modal-footer">
                            <button ref={closeModal} type="button" className="btn btn-outline-danger" onClick={() => reset()} data-bs-dismiss="modal"> <Slash size={20} /> Cancelar </button>
                            <button type="submit" className="btn btn-outline-primary"> <Save size={20} /> Guardar </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
